import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import AboutHero from "./components/AboutHero";
import AboutValues from "./components/AboutValues";
import AboutQuote from "./components/AboutQuote";

export default function About() {
  return (
    <div className="bg-[#FAF7F0] min-h-screen">
      <Navbar />
      <AboutHero />
      <AboutValues />
      <AboutQuote />
      <Footer />
    </div>
  );
}
